import * as Yup from "yup";

export function initialValues(grade) {
  return {
    levelId: grade?.levelId || "",
    name: grade?.name || "",
  };
}

export function validationSchema() {
  return Yup.object({
    levelId: Yup.number().required("El nivel es obligatorio"),
    name: Yup.string().required("El nombre es obligatorio"),
  });
}
